var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"rounded",style:({
    backgroundColor: _vm.$vuetify.theme.currentTheme.secondarySheet,
  }),attrs:{"outlined":"","small":"","text":"","icon":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }